<div class="kl-upload-basic" [class.kl-upload-basic--disabled]="disabled()">
  <input
    #nativeInput
    type="file"
    class="kl-upload-basic__native"
    [accept]="acceptedFileExtentions()"
    [multiple]="multiple()"
    [disabled]="disabled()"
    (change)="onNativeChange($event)" />

  <span class="kl-upload-basic__name" [title]="fileNameLabel()">{{ fileNameLabel() || '&nbsp;' }}</span>

  <span class="kl-upload-basic__actions">
    <button
      type="button"
      class="kl-upload-basic__btn ph ph-paperclip"
      [disabled]="disabled()"
      [title]="'select' | translate"
      [attr.aria-label]="'select' | translate"
      (click)="choose()"></button>
    @if (fileContent()) {
      @if (canPreview()) {
        <button
          type="button"
          class="kl-upload-basic__btn kl-upload-basic__btn--eye ph ph-eye"
          [title]="'upload_show_file' | translate"
          [attr.aria-label]="'upload_show_file' | translate"
          (click)="showFileRequest.emit()"></button>
      }
      <button
        type="button"
        class="kl-upload-basic__btn kl-upload-basic__btn--clear ph ph-x"
        [title]="'delete' | translate"
        [attr.aria-label]="'delete' | translate"
        (click)="clear()"></button>
    }
  </span>
</div>

@if (errorMessage) {
  <small class="kl-upload-basic__error">{{ errorMessage }}</small>
}
